import React, { useState } from 'react';
import '../styles/GalleryPage.css';
import vid1 from '../assets/Gallary/videos/vid_1.mp4';

// Import all gallery images
import img1 from '../assets/Gallary/page/20230415_165137.jpg';
import img2 from '../assets/Gallary/page/20230528_132128.jpg';
import img3 from '../assets/Gallary/page/20230528_132158.jpg';
import img4 from '../assets/Gallary/page/20230528_132246.jpg';
import img5 from '../assets/Gallary/page/20230528_132303.jpg';
import img6 from '../assets/Gallary/page/20230528_132419.jpg';
import img7 from '../assets/Gallary/page/20230528_133314.jpg';
import img8 from '../assets/Gallary/page/IMG-20230528-WA0071.jpg';
import img9 from '../assets/Gallary/page/IMG-20230529-WA0078.jpg';
import img10 from '../assets/Gallary/page/IMG-20230529-WA0089.jpg';
import img11 from '../assets/Gallary/page/IMG-20230531-WA0001.jpg';
import img12 from '../assets/Gallary/page/IMG-20230606-WA0004.jpg';
import img13 from '../assets/Gallary/page/IMG-20230606-WA0013.jpg';
import img14 from '../assets/Gallary/page/pic04.jpg';
import img15 from '../assets/Gallary/page/pic05.jpg';
import img16 from '../assets/Gallary/page/pic06.jpg';
import img17 from '../assets/Gallary/page/pic07.jpg';
import img18 from '../assets/Gallary/page/WhatsApp Image 2022-11-26 at 5.48.49 PM.jpeg';
import img19 from '../assets/Gallary/page/WhatsApp Image 2023-01-08 at 10.22.42 PM.jpeg';
import img20 from '../assets/Gallary/page/WhatsApp Image 2023-01-08 at 10.22.42 PM (3).jpeg';

const GalleryPage = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryImages = [
    img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
    img11, img12, img13, img14, img15, img16, img17, img18, img19, img20
  ];

  return (
    <div className="gallery-page">
      <section className="gallery-hero">
        <div className="video-background">
          <video
            autoPlay
            muted
            playsInline
            loop
          >
            <source src={vid1} type="video/mp4" />
          </video>
          <div className="overlay"></div>
        </div>
        
        <div className="gallery-hero-content">
          <h1>Transforming Spaces, Exceeding Expectations</h1>
          <p>Experience the art of pristine cleaning through our portfolio of stunning transformations. Each space tells a story of dedication, attention to detail, and the pursuit of perfection that has earned us the trust of countless satisfied clients.</p>
          <div className="gallery-stats">
            <div className="stat-item">
              <span className="stat-number">500+</span>
              <span className="stat-label">Happy Clients</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">98%</span>
              <span className="stat-label">Satisfaction Rate</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">5000+</span>
              <span className="stat-label">Spaces Transformed</span>
            </div>
          </div>
        </div>
      </section>

      <section className="gallery-board">
        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <div 
              key={index} 
              className="gallery-item"
              onClick={() => setSelectedImage(image)}
            >
              <img src={image} alt={`Gallery image ${index + 1}`} />
            </div>
          ))}
        </div>

        {selectedImage && (
          <div className="gallery-modal" onClick={() => setSelectedImage(null)}>
            <div className="modal-content">
              <img src={selectedImage} alt="Enlarged gallery image" />
              <button className="close-button" onClick={() => setSelectedImage(null)}>×</button>
            </div>
          </div>
        )}
      </section>
    </div>
  );
};

export default GalleryPage; 